import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('NotificationHeading', null, {
    withChildren: true,
});
